function isReferralVisitor() {

  const params = new URLSearchParams(window.location.search);

  if (params.has('ref')) {
    sessionStorage.setItem('ucari_referral_visitor', 'true');
    return true;
  }

  return sessionStorage.getItem('ucari_referral_visitor') === 'true';
}

document.addEventListener('DOMContentLoaded', function () {

  const overlay = document.getElementById('ucari-popup-overlay');

  if (!overlay) {
    return;
  }

  const closeButton = overlay.querySelector('.ucari-popup-close');
  const dismissButton = overlay.querySelector('.ucari-popup-dismiss');

  const form = document.getElementById('ucari-popup-form');
  const submitButton = overlay.querySelector('.ucari-popup-submit');

  const success = overlay.querySelector('.ucari-popup-success');

  if (!closeButton || !dismissButton || !form || !submitButton || !success) {
    return;
  }

  const DISMISSED_KEY = 'ucari_popup_dismissed';
  const SUBSCRIBED_KEY = 'ucari_popup_subscribed';

  const SHOW_AFTER = 8000;

  const THIRTY_DAYS =
    30 * 24 * 60 * 60 * 1000;

  function hasBeenDismissed() {

    const dismissed = localStorage.getItem(DISMISSED_KEY);

    if (!dismissed) {
      return false;
    }
    const dismissedTime = parseInt(dismissed, 10);
    return Date.now() - dismissedTime < THIRTY_DAYS;
  }


function hasSubscribed() {
  return localStorage.getItem(SUBSCRIBED_KEY) === 'true';
}

function openPopup() {

  if (isReferralVisitor()) {
    return;
  }

  if (hasBeenDismissed() || hasSubscribed()) {
    return;
  }

  overlay.classList.add('is-visible');
  document.body.style.overflow = 'hidden';

}


  function closePopup(remember = true) {

    overlay.classList.remove('is-visible');

    document.body.style.overflow = '';

    if (remember) {
      localStorage.setItem(
        DISMISSED_KEY,
        Date.now().toString()
      );

    }

  }

  closeButton.addEventListener('click', function () {
    closePopup(true);
  });


  dismissButton.addEventListener('click', function () {
    closePopup(true);
  });


  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) {
      closePopup(true);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePopup(true);
    }
  });

  form.addEventListener('submit', function () {
    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    /*
      The form posts directly to Mailchimp in the
      hidden iframe, so the visitor stays on Shopify.
    */

    setTimeout(function () {

      localStorage.setItem(
        SUBSCRIBED_KEY,
        'true'
      );

      form.style.display = 'none';

      dismissButton.style.display = 'none';

      overlay.querySelector(
        '.ucari-popup-description'
      ).style.display = 'none';

      overlay.querySelector(
        '.trust'
      ).style.display = 'none';

      success.hidden = false;

    }, 1200);

  });


  /*
    Don't annoy yourself while using
    the Shopify theme customizer.
  */

  if (window.Shopify && Shopify.designMode) {
    return;
  }

  if (!isReferralVisitor()) {
    setTimeout(openPopup, SHOW_AFTER);
  }

});